import StyledButton from './styled-button';

export default StyledButton;